"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __aws_sdk_middleware_header_default = require("@aws-sdk/middleware-header-default");
var __aws_sdk_middleware_stack = require("@aws-sdk/middleware-stack");
var ListBuckets_1 = require("../model/ListBuckets");
var ListBucketsCommand = /** @class */ (function () {
    function ListBucketsCommand(input) {
        this.input = input;
        this.model = ListBuckets_1.ListBuckets;
        this.middlewareStack = new __aws_sdk_middleware_stack.MiddlewareStack();
    }
    ListBucketsCommand.prototype.resolveMiddleware = function (clientStack, configuration) {
        var handler = configuration.handler;
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
            model: this.model
        };
        stack.add(__aws_sdk_middleware_header_default.headerDefault({
            "Content-Type": "application/octet-stream"
        }), {
            step: "build",
            priority: -50,
            tags: { "Content-Type": true }
        });
        return stack.resolve(handler(handlerExecutionContext), handlerExecutionContext);
    };
    return ListBucketsCommand;
}());
exports.ListBucketsCommand = ListBucketsCommand;
//# sourceMappingURL=ListBucketsCommand.js.map